import { Navigate } from '@tanstack/react-router';
import Home from './Home';
import Resources from '@src/app-pages/Resources/ResourcesHome';
import { useUserProfile } from '@hooks';
import { useUserRoleCapabilities } from '@stores';

const Main = () => {
  const { isUserRoleValid, isUsaceRegulator, isExternalAgency, isHelpDesk } = useUserProfile();
  const canCreateRequest = useUserRoleCapabilities((state) => state.roleCapabilities.createRequest);
  const canViewDashboard = useUserRoleCapabilities((state) => state.roleCapabilities.viewDashboard);
  const shouldRouteToRoleDashboard = isUsaceRegulator || isExternalAgency || isHelpDesk;

  if (!isUserRoleValid) {
    return <Resources />;
  }

  if (canCreateRequest) {
    return <Home />;
  }

  if (shouldRouteToRoleDashboard && canViewDashboard) {
    return <Navigate to='/dashboard' replace />;
  }

  return <Resources />;
};

export default Main;
